"use client";

import { Axiom } from "@axiomhq/js";
import { AxiomJSTransport, ConsoleTransport, Logger } from "@axiomhq/logging";
import { createWebVitalsComponent } from "@axiomhq/react";

import { env } from "@/web/lib/env";

const axiomClient = new Axiom({
  token: env.VITE_AXIOM_TOKEN,
});

const axiomLogger = new Logger({
  transports: [
    new AxiomJSTransport({
      axiom: axiomClient,
      dataset: env.VITE_AXIOM_DATASET,
    }),
    new ConsoleTransport(),
  ],
});

const loggerBase = axiomLogger.with({
  env: env.VITE_TYCHO_ENV,
});

const logger: Logger & {
  withError: (message: string, error: Error, args?: Record<string, unknown>) => void;
} = Object.assign(loggerBase, {
  withError: (message: string, error: Error, args?: Record<string, unknown>) => {
    loggerBase.error(message, { ...args, error });
  },
});

// const useLogger = createUseLogger(logger); // rf: not sure why we'd use this yet
const WebVitals = createWebVitalsComponent(
  // oxlint-disable-next-line typescript/no-explicit-any createWebVitalsComponent expects the SDK Logger type; our wrapped logger is compatible at runtime.
  logger as any,
);

export { logger, WebVitals };
